












































import { Component, Vue } from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { clientsModule, subscriptionModule } from '@/store';

@Component({
  name: 'subscriptions-page',
  components: {
    BaseLayout,
  },
})
export default class SubscriptionsPage extends Vue {
  get client() {
    return clientsModule.model;
  }

  get subscriptions() {
    return subscriptionModule.list;
  }

  async created() {
    if (this.client && this.client.id != null) {
      subscriptionModule.fetchSubscriptions(this.client.id);
    }
  }

  openShopping(id: number | string) {
    const clientId = String(this.client && this.client.id);
    this.$router.push({
      name: 'shopping',
      params: { shoppingId: String(id), clientId },
    });
  }
}
